import { Authorization, Fluent } from "@serenity-is/corelib";
import { IdleTimeout } from "@serenity-is/pro.extensions";

Fluent.ready(() => {
    var meta = Fluent(document.querySelector('meta[name=username]'));
    if ((meta.attr('content')) || (!meta.length && Authorization.isLoggedIn)) {
        new IdleTimeout({
            activityTimeout: 4 * 60 * 60,
            warningDuration: 2 * 60,
            keepAliveTimer: 120
        });
    }
});
